import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { api } from '../../services/api';


interface CashTransaction {
    id: string;
    amount: number;
    tripCode?: string;
    description?: string;
    cashInHand?: string;
    cashUserName?: string;
    cashTrnDate?: string;
    tripDate?: string;
}

interface CashTrnReportState {
    driverData?: CashTransaction[];
    operatorData?: CashTransaction[];
    adminData?: CashTransaction[];
    loading?: boolean;
    error?: string | null;
}

const initialState: CashTrnReportState = {
    driverData: [],
    operatorData: [],
    adminData: [],
    loading: false,
    error: null,
};

// Fetch driver data
export const fetchDriverCashTrns = createAsyncThunk(
    'cashTrnReport/fetchDriver',
    async (_, { rejectWithValue }) => {
        try {
            const response: any = await api.getCashTrnsByInhand('DRIVER');
            return response.data || [];
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch driver data');
        }
    }
);

// Fetch operator data
export const fetchOperatorCashTrns = createAsyncThunk(
    'cashTrnReport/fetchOperator',
    async (_, { rejectWithValue }) => {
        try {
            const response: any = await api.getCashTrnsByInhand('OPERATOR');
            return response.data || [];
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch operator data');
        }
    }
);

// Fetch admin data
export const fetchAdminCashTrns = createAsyncThunk(
    'cashTrnReport/fetchAdmin',
    async (_, { rejectWithValue }) => {
        try {
            const response: any = await api.getCashTrnsByInhand('ADMIN');
            return response.data || [];
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch adnin data');
        }
    }
);

const cashTrnReportSlice = createSlice({
    name: 'cashTrnReport',
    initialState,
    reducers: {
        clearData: (state) => {
            state.driverData = [];
            state.operatorData = [];
            state.adminData = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // Driver data
        builder.addCase(fetchDriverCashTrns.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchDriverCashTrns.fulfilled, (state, action) => {
            state.driverData = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchDriverCashTrns.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
        builder.addCase(fetchOperatorCashTrns.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchOperatorCashTrns.fulfilled, (state, action) => {
            state.operatorData = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchOperatorCashTrns.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });

        // Manager data
        builder.addCase(fetchAdminCashTrns.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchAdminCashTrns.fulfilled, (state, action) => {
            state.adminData = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchAdminCashTrns.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
    },
});

export default cashTrnReportSlice.reducer;